import { FileText } from 'lucide-react';
import { AssessmentStartedEvent as AssessmentStartedEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: AssessmentStartedEventType;
}

export default function AssessmentStartedEvent({ event }: Props) {
  return (
    <EventShell
      color="indigo"
      icon={<FileText className="w-3.5 h-3.5" />}
      title="Assessment Started"
      timestamp={event.created_at}
    >
      {event.payload.assessment_name && <p>{event.payload.assessment_name}</p>}
    </EventShell>
  );
}
